import { connect } from 'react-redux';

import { IState } from '../../store';
import { INewObject } from '../../types';
import { INewObjectStatsProps, NewObjectStats } from './newobject-stats';
import { isAbExperimentNewBuildingFeatures } from '../../utils/newbuilding_features';

export function mapStateToProps(state: IState): INewObjectStatsProps {
  return {
    newObject: state.offerData.newObject as INewObject,
    offer: state.offerData.offer,
    isABNewbuildingFeaturesExperimentEnabled: isAbExperimentNewBuildingFeatures(state.experiments),
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const NewObjectStatsContainer = connect<INewObjectStatsProps, any, any>(mapStateToProps)(NewObjectStats);
